import en from '@ihme/common/locale/en';
import ageGroups from '@ihme/common/locale/en/age-groups';
import locations from '@ihme/common/locale/en/locations';
import measures from '@ihme/common/locale/en/measures';
import metrics from '@ihme/common/locale/en/metrics';
import rei from '@ihme/common/locale/en/rei';

export default {
    ...en,
    ...ageGroups,
    ...locations,
    ...measures,
    ...metrics,
    ...metrics,
    ...rei,

    /**
     * Browser Titles
     */
    browser_title_home: `Women and Cardiovascular Disease Commission`,
    browser_title_global_impact: 'Global Impact - Women and Cardiovascular Disease Commission',
    browser_title_trends: 'Trends - Women and Cardiovascular Disease Commission',
    browser_title_breakdown: 'Breakdown - Women and Cardiovascular Disease Commission',
    browser_title_factsheets: 'Factsheets - Women and Cardiovascular Disease Commission',

    /**
     * Navigation
     */
    navigation_global_impact: 'Global Impact',
    navigation_trends: 'Trends',
    navigation_breakdown: 'Breakdown',
    navigation_factsheets: 'Factsheets',
    navigation_about: 'About',
    navigation_our_aims: 'Our Aims',
    navigation_commissioners_and_contributors: 'Commissioners and Collaborators',
    navigation_sponsors: 'Sponsors',
    navigation_resources: 'Resources',
    navigation_templates: 'Communication Templates',
    navigation_links: 'Links',
    navigation_events: 'Events',
    navigation_data_maps: 'Data Maps',
    navigation_reports: 'Reports',
    navigation_home: 'Home',

    /**
     * Global Impact Scene
     */
    global_impact_scene_title: 'Global Impact',
    global_impact_description:
        '<p>Click the play button to see how fatal or non-fatal measures of cardiovascular disease in women have changed from 1990-2022, or drag the timeline to focus on specific years. Use the heat bar to view countries that fall between specific values selected. As you drag the heat bar minimum and maximum arrows, only countries within that range will appear in color. Select the download button at the top of the chart to save and share your findings. As you compare locations, select “Age Standardized” rate per 100,000 which adjusts for differences in ages and population size across countries.</p>',
    global_impact_chart_title: '%cause% in Females, %year%',
    global_impact_chart_subtitle: '%ageGroup%, %measure% %metric%',
    /**
     * Trends Scene
     */
    trends_scene_title: 'Trends',
    trends_scene_description:
        '<p>Use the refinement settings to view trends for age groups, measure, specific cardiovascular diseases, and locations over time. Drag the timeline at the bottom of the page to narrow in on years of interest.</p>',
    trends_chart_title: '%cause% in Females, %measure% %metric%, %yearsRange%',
    trends_chart_subtitle: '%location%, %ageGroup%',

    /**
     * Breakdown Scene
     */
    breakdown_scene_title: 'Breakdown',
    breakdown_scene_description:
        '<p>Select or deselect countries or socio-demographic index (SDI)* by typing in the location search bar or selecting from the dropdown. Hover over each specific cardiovascular disease to view the details for your selection of age group, unit, measure and year. Select the download arrow to save an image of the chart and share your findings.</p>',
    breakdown_scene_footnote: '*SDI: A summary measure that identifies where countries or other geographic areas sit on the spectrum of development. Expressed on a scale of 0 to 1, SDI is a composite average of the rankings of the incomes per capita, average educational attainment, and fertility rates of all areas in the GBD study.',
    breakdown_chart_title: 'Cardiovascular Diseases Breakdown in Females, %measure% %metric% in %year%',
    breakdown_chart_subtitle: '%location%, %ageGroup%',

    /**
     * Factsheets Scene
     */
    factsheets_scene_title: 'Factsheets About Cardiovascular Disease In',
    factsheets_scene_sub_title: 'Findings from the Global Burden of Disease',

    factsheets_scene_yll_lowest_rates: 'Lowest Rates',
    factsheets_scene_yll_highest_rates: 'Highest Rates',
    factsheets_scene_yll_location_stat:
        'In %location% %years% years of life are lost per 100,000 due to Cardiovascular Disease in 2022.',
    factsheets_yll_chart_title: 'Years of Life Lost in Females',
    factsheets_yll_chart_subtitle: '%age_group_id%, %year%',

    factsheets_scene_deaths_highlight_deaths: '%amount% deaths',
    factsheets_deaths_chart_title: 'Deaths From Cardiovascular Disease in Females',
    factsheets_deaths_chart_subtitle: 'Cardiovascular disease continues to be an important challenge to women’s health worldwide',

    factsheets_risks_chart_title: 'Cardiovascular Diseases Risks Breakdown in Females, %year%',

    metric_3: 'Rate/100K',

    measure_1_full_name: 'Deaths',
    measure_2_full_name: 'Disability-adjusted life years',
    measure_3_full_name: 'Years lived with disability',
    measure_4_full_name: 'Years of life lost',
    measure_5_full_name: 'Prevalence',
    measure_6_full_name: 'Incidence',
    measure_25_full_name: 'Maternal mortality ratio',

    tooltip_measure_1: 'deaths',
    tooltip_measure_2: 'DALYs',
    tooltip_measure_3: 'YLDs',
    tooltip_measure_4: 'YLLs',
    tooltip_measure_5: 'cases',
    tooltip_measure_6: 'cases',
    tooltip_measure_25: 'MMR',

    long_metric_1: 'Number',
    long_metric_3: 'Rate (per 100,000)',

    filter_year_title: 'Year:',

    cause_294: 'All causes',
    cause_369: 'Maternal hypertensive disorders',
    cause_386: 'Acute ischemic stroke severity level 1',
    cause_387: 'Acute ischemic stroke severity level 2',
    cause_388: 'Acute ischemic stroke severity level 4',
    cause_389: 'Acute ischemic stroke severity level 3',
    cause_390: 'Acute ischemic stroke severity level 5',
    cause_391: 'Chronic ischemic stroke severity level 1',
    cause_392: 'Chronic ischemic stroke severity level 2',
    cause_393: 'Chronic ischemic stroke severity level 4',
    cause_394: 'Chronic ischemic stroke severity level 3',
    cause_395: 'Chronic ischemic stroke severity level 5',
    cause_396: 'Acute intracerebral hemorrhage severity level 1',
    cause_397: 'Acute intracerebral hemorrhage severity level 2',
    cause_398: 'Acute intracerebral hemorrhage severity level 4',
    cause_399: 'Acute intracerebral hemorrhage severity level 3',
    cause_400: 'Acute intracerebral hemorrhage severity level 5',
    cause_401: 'Chronic intracerebral hemorrhage severity level 1',
    cause_402: 'Chronic intracerebral hemorrhage severity level 2',
    cause_403: 'Chronic intracerebral hemorrhage severity level 4',
    cause_404: 'Chronic intracerebral hemorrhage severity level 3',
    cause_405: 'Chronic intracerebral hemorrhage severity level 5',
    cause_409: 'Acute myocarditis',
    cause_491: 'Cardiovascular diseases',
    cause_492: 'Rheumatic heart disease',
    cause_493: 'Ischemic heart disease',
    cause_494: 'Stroke',
    cause_495: 'Ischemic stroke',
    cause_496: 'Intracerebral hemorrhage',
    cause_497: 'Subarachnoid hemorrhage',
    cause_498: 'Hypertensive heart disease',
    cause_499: 'Cardiomyopathy and myocarditis',
    cause_500: 'Atrial fibrillation and flutter',
    cause_501: 'Aortic aneurysm',
    cause_502: 'Peripheral artery disease',
    cause_503: 'Endocarditis',
    cause_504: 'Non-rheumatic valvular heart disease',
    cause_507: 'Other cardiovascular and circulatory diseases',
    cause_938: 'Alcoholic cardiomyopathy',
    cause_942: 'Myocarditis',
    cause_944: 'Other cardiomyopathy',
    cause_946: 'Asymptomatic chronic ischemic stroke',
    cause_947: 'Asymptomatic chronic intracerebral hemorrhage',
    cause_964: 'Asymptomatic peripheral arterial disease',
    cause_968: 'Non-rheumatic calcific aortic valve disease',
    cause_969: 'Non-rheumatic degenerative mitral valve disease',
    cause_970: 'Other non-rheumatic valve diseases',
    cause_1041: 'Symptomatic claudication due to peripheral arterial disease',
    cause_1116: 'Rheumatic heart disease, without heart failure',
    cause_5168: 'Acute subarachnoid hemorrhage severity level 1',
    cause_5171: 'Acute subarachnoid hemorrhage severity level 2',
    cause_5174: 'Acute subarachnoid hemorrhage severity level 3',
    cause_5177: 'Acute subarachnoid hemorrhage severity level 4',
    cause_5180: 'Acute subarachnoid hemorrhage severity level 5',
    cause_5183: 'Asymptomatic chronic subarachnoid hemorrhage',
    cause_5186: 'Chronic subarachnoid hemorrhage severity level 1',
    cause_5189: 'Chronic subarachnoid hemorrhage severity level 2',
    cause_5192: 'Chronic subarachnoid hemorrhage severity level 3',
    cause_5195: 'Chronic subarachnoid hemorrhage severity level 4',
    cause_5198: 'Chronic subarachnoid hemorrhage severity level 5',
    cause_6113: 'Acute intracerebral hemorrhage',
    cause_6116: 'Acute ischemic stroke',
    cause_6131: 'Acute subarachnoid hemorrhage',
    cause_6167: 'Angina due to ischemic heart disease',
    cause_6245: 'Chronic intracerebral hemorrhage',
    cause_6248: 'Chronic ischemic stroke',
    cause_6266: 'Chronic subarachnoid hemorrhage',
    cause_6635: 'Myocardial infarction due to ischemic heart disease',

    chart_error_no_data: 'Please update your query for results',
};
